export const environment = {
  //SSO APIs
  SSOauthAPI: "https://api.auth.myzpax.com/api",
  ssoUserInfoAPI: "https://api.auth.myzpax.com/connect/userinfo",
  ssoConnectAPI: "https://api.auth.myzpax.com/connect/authorize",
  ssoLogoutAPI: "https://api.auth.myzpax.com/api/account/logout",
  ssoLoginUrl: "https://auth.myzpax.com/sso/login",

  endpoint: "https://api.rehabconnect.com/api/v1",

  zpaxEsignatureDocumentRedirectEndPoint:
    "https://myzpax.com/app/document-signature/documents",
  zpaxChangepasswordEndpoint: "https://myzpax.com/user/password-and-security",

  sessionEncryptionKey:
    "fCCmUMuOM0kuDCuLe7naPOo6sNvlhXshFhZEVomw5XAS9vR7M0YGxbeaeYhiNmOC",
  idleTimeBeforeLocking: 1800,
  idleTimeBeforeTerminating: 2400,
  clientId: "b36f97928dac466a86f1d0e0494eab10",
  userDetailsAPI: "/user/get",
  authorizationAPI: "/authorization",
  AWS_REGION: "us-east-1",
  AWS_ACCESS_KEY_ID: "",
  AWS_SECRET_ACCESS_KEY: "",
  AWS_SESSION_TOKEN: "",
  biDashboardSupersetDomain: "https://6cef2d04.us1a.app.preset.io",

  /**Matomo Analytics */
  enableMatomo: true,
  matomo: {
    trackerUrl: "https://matomo.z-pax.com/",
    siteId: 6
  }
};
